import DateInput from "../../../components/common/inputs/DateInput";

export default function CustomerReportsFilter({ filterDataHandler }) {
  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="admin-filter-grid">
        <DateInput
          label={"از تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, from: e })}
        />
        <DateInput
          label={"تا تاریخ"}
          onChange={(e) => filterDataHandler({ page: 1, to: e })}
        />
      </div>
    </div>
  );
}
